/**
 * Función genérica para actualizar una fila en una colección por ID.
 * @param {Object} options
 * @param {Object} options.selectedItem - Objeto seleccionado.
 * @param {Array} options.data - Lista original.
 * @param {Function} options.setData - Función para actualizar estado.
 * @param {Function} options.apiUpdateFunction - Función de API que recibe (id, payload).
 * @param {String} [options.idField='id'] - Nombre del campo identificador.
 * @param {Object} [options.updatePayload={}] - Objeto con los campos a modificar.
 * @param {Function} [options.closeDialog=() => {}] - Función opcional para cerrar modal.
 */
export const handleGenericUpdate = async ({
    selectedItem,
    data,
    setData,
    apiUpdateFunction,
    idField = "id",
    updatePayload = {},
    closeDialog = () => { },
}) => {
    if (selectedItem) {
        const idValue = selectedItem[idField];
        const newData = data.map((item) =>
            item[idField] === idValue ? { ...item, ...updatePayload } : item
        );

        try {
            await apiUpdateFunction(idValue, updatePayload);
            setData(newData);
            closeDialog();
        } catch (error) {
            console.error("Error al actualizar el registro:", error.message);
        }
    }
};
